import axios from 'src/utils/axios';

// SP'ler JSON'u string olarak donduruyor; axios cogu zaman kendisi parse ediyor
// ama content-type text/plain gelirse string kaliyor. Iki durumu da karsiliyoruz.
export const coz = (veri, bosDeger) => {
  if (veri === null || veri === undefined || veri === '') return bosDeger;
  if (typeof veri !== 'string') return veri;
  try {
    return JSON.parse(veri);
  } catch {
    return bosDeger;
  }
};

export const dizi = veri => {
  const c = coz(veri, []);
  return Array.isArray(c) ? c : [];
};

// Servis listesi yönetici olmayana yalnız kendi servisiyle gelir
export const getLookuplar = async () => {
  const { data } = await axios.get('/GetHavcOfferCombos');
  const c = coz(data, {});
  return {
    yoneticiMi: c.YoneticiMi !== false,
    kullaniciServisId: Number(c.KullaniciServisId) || 0,
    bayiler: Array.isArray(c.bayiler) ? c.bayiler : [],
    servisler: Array.isArray(c.servisler) ? c.servisler : [],
    durumlar: Array.isArray(c.durumlar) ? c.durumlar : []
  };
};

export const getKatalog = async () => {
  const { data } = await axios.get('/GetHavcOfferCatalog');
  return dizi(data);
};

export const getTeklifler = async ({ bayiId = 0, durum = 0, arama = '' } = {}) => {
  const { data } = await axios.get(
    `/GetHavcOffers/${bayiId || 0}/${durum || 0}/${encodeURIComponent(arama || '')}`
  );
  return dizi(data);
};

export const getTeklifDetay = async teklifId => {
  const { data } = await axios.get(`/GetHavcOfferDetail/${teklifId}`);
  const detay = coz(data, null);
  if (!detay) return null;
  return { ...detay, Kalemler: Array.isArray(detay.Kalemler) ? detay.Kalemler : [] };
};

export const teklifKaydet = async model => {
  const { data } = await axios.post('/SetHavcOffer', {
    TeklifId: model.TeklifId || 0,
    ProjeAdi: model.ProjeAdi,
    MusteriAdSoyad: model.MusteriAdSoyad,
    MusteriTelefon: model.MusteriTelefon,
    MusteriAdres: model.MusteriAdres,
    BayiId: model.BayiId,
    ServisId: model.ServisId,
    Durum: model.Durum || 1,
    GecerlilikGun: Number(model.GecerlilikGun) || 15,
    ParaBirimi: model.ParaBirimi || 'TRY',
    DovizKuru: Number(model.DovizKuru) || 1,
    SarfMalzemeOrani: Number(model.SarfMalzemeOrani) || 0,
    IndirimOrani: Number(model.IndirimOrani) || 0,
    KdvOrani: Number(model.KdvOrani) || 0,
    Sartlar: model.Sartlar,
    FiyatListesiId: model.FiyatListesiId || null,
    GrupIndirimleri: model.GrupIndirimleri || null,
    // Birim fiyat gonderilmiyor; SP katalogdan / fiyat listesinden okuyor.
    Kalemler: (model.Kalemler || [])
      .filter(k => k.KalemId || (k.FiyatListesiKalemId && Number(k.Miktar) > 0))
      .map(k => ({
        KalemId: k.KalemId || 0,
        FiyatListesiKalemId: k.FiyatListesiKalemId || 0,
        Miktar: Number(k.Miktar) || 0
      }))
  });
  // SP hatası { Basarili: false, Mesaj } olarak geliyor
  return coz(data, { Basarili: true });
};

/** Teklif formu PDF'ini indirir. Dosya adini sunucu Content-Disposition ile veriyor. */
export const teklifPdfIndir = async (teklifId, teklifNo) => {
  const cevap = await axios.get(`/GetHavcOfferPdf/${teklifId}`, { responseType: 'blob' });

  const url = window.URL.createObjectURL(new Blob([cevap.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${teklifNo || `Teklif-${teklifId}`}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 5000);
};

export const teklifDurumGuncelle = async (teklifId, durum) => {
  const { data } = await axios.post('/SetHavcOfferStatus', { TeklifId: teklifId, Durum: durum });
  return coz(data, { Basarili: false, Mesaj: 'İşlem sonucu alınamadı.' });
};

export const teklifSil = async teklifId => {
  const { data } = await axios.get(`/DeleteHavcOffer/${teklifId}`);
  return coz(data, { Basarili: true });
};

/** Toplamlar SP tarafinda da hesaplaniyor; bu ekrandaki anlik onizleme icin. */
export const toplamlariHesapla = (teklif, katalog = []) => {
  const kalemler = teklif?.Kalemler || [];

  // SP ile aynı: satır tutarı (grup indirimi düşülmüş) kuruşa yuvarlanır
  let brutToplam = 0;
  const araToplam = kalemler.reduce((acc, satir) => {
    const k = katalog.find(x => x.Id === satir.KalemId);
    const birimFiyat = k ? Number(k.BirimFiyat) : Number(satir.BirimFiyat) || 0;
    const brut = birimFiyat * (Number(satir.Miktar) || 0);
    brutToplam += Math.round(brut * 100) / 100;
    return acc + Math.round(brut * (100 - (Number(satir.GrupIndirimOrani) || 0))) / 100;
  }, 0);
  const grupIndirimi = brutToplam - araToplam;

  const sarf = araToplam * ((Number(teklif?.SarfMalzemeOrani) || 0) / 100);
  const indirimOncesi = araToplam + sarf;
  const indirim = indirimOncesi * ((Number(teklif?.IndirimOrani) || 0) / 100);
  const kdvMatrahi = indirimOncesi - indirim;
  const kdv = kdvMatrahi * ((Number(teklif?.KdvOrani) || 0) / 100);

  return { brutToplam, grupIndirimi, araToplam, sarf, indirim, kdvMatrahi, kdv, genelToplam: kdvMatrahi + kdv };
};
